"use strict";

import "./IntervalEditor.css";
import DateTimePicker from "./../DateTimePicker";
import Checkbox from "./../Checkbox";
import Toast from "./../Toast";
import React from "react";
import lang from "./../../lang";

export default class IntervalEditor extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState(){
		let from = this.props.interval.from;
		let to = this.props.interval.to;
		
		if(!this.props.nullable){
			from = from || Date.now(),
			to = to || Date.now()
		}
		
		this.state = {
			from:		this.props.interval.from,
			to:			this.props.interval.to,
			backupFrom:	this.props.interval.from || Date.now(),
			backupTo:	this.props.interval.to || Date.now()
		}
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.interval.from != this.props.interval.from ||
			nextProps.interval.to != this.props.interval.to
		) {
			this.setState({
				from:		nextProps.interval.from,
				to:			nextProps.interval.to,
				backupFrom:	nextProps.interval.from || Date.now(),
				backupTo:	nextProps.interval.to || Date.now()
			});
		}
	}
	
	componentDidUpdate(_, prevState) {
		if (prevState.from !== null && this.state.from === null) {
			this.setState({backupFrom: prevState.from});
		}
		else if (prevState.to !== null && this.state.to === null) {
			this.setState({backupTo: prevState.to});
		}
	}
	
	isValidInterval(from, to){
		if (from === null || to === null) {
			return true;
		}
		if (from > to) {
			new Toast(lang.INVALID_INTERVAL, "orange");
			return false;
		}
		return true;
	}
	
	handleChange() {
		if (this.isValidInterval(this.state.from, this.state.to)) {
			this.props.onChange({
				from: this.state.from,
				to: this.state.to
			});
		}
	}
	
	renderFromCheckbox(){
		if(this.props.nullable){
			let fromCheckboxProps = {
				checked: (this.state.from !== null),
				onChange: value => {
					this.setState({from: value ? this.state.backupFrom : null}, () => this.handleChange());
				}
			}
			
			return (<Checkbox {...fromCheckboxProps} />);
		}
	}
	
	renderToCheckbox(){
		if(this.props.nullable){
			let toCheckboxProps = {
				checked: (this.state.to !== null),
				onChange: value => {
					this.setState({to: value ? this.state.backupTo : null}, () => this.handleChange());
				}
			}
			
			return (<Checkbox {...toCheckboxProps} />);
		}
	}
	
	render(){
	
		let fromDateTimePickerProps = {
			dateTime: this.state.from ? new Date(this.state.from) : new Date(this.state.backupFrom),
			disabled: this.state.from === null,
			onChange: dateTime => {
				this.setState({from: dateTime.getTime()}, () => this.handleChange());
			}
		}
		
		let toDateTimePickerProps = {
			dateTime: this.state.to ? new Date(this.state.to) : new Date(this.state.backupTo),
			disabled: this.state.to === null,
			onChange: dateTime => {
				this.setState({to: dateTime.getTime()}, () => this.handleChange());
			}
		}
	
		return(
			<div className="IntervalEditor">
				<div>
					{this.renderFromCheckbox()}
					<DateTimePicker {...fromDateTimePickerProps} />
					<div id="hyphen">-</div>
					{this.renderToCheckbox()}
					<DateTimePicker {...toDateTimePickerProps} />
				</div>
			</div>
		);
	}
}

IntervalEditor.propType = {
	interval: React.PropTypes.shape({
		from:	React.PropTypes.number,
		to:		React.PropTypes.number
	}),
	nulllable: React.PropTypes.bool,
	onChange: React.PropTypes.func
}

IntervalEditor.defaultProps = {
	interval: {from: null, to: null},
	nullable: true,
	onChange: interval => {}
}


// WEBPACK FOOTER //
// ./~/vwa/components/IntervalEditor/IntervalEditor.jsx